import { ReactElement } from "react";

// Nearest equivalents to mobile's receipt/layers/gift set, which this repo does
// not carry - worth a design pass.
import { Coupon, Database, Gift } from "@assets";
import { PartnerBankColors } from "@ctypes";
import { i18n, Translations } from "@i18n";
import { Card, Feature, FeatureIcon, FeatureSubtitle, FeatureTitle, Motivational } from "./cardStyles";

type FeatureItem = {
  icon: ReactElement;
  titleKey: keyof typeof Translations;
  subtitleKey: keyof typeof Translations;
};

const FEATURES: FeatureItem[] = [
  {
    icon: <Coupon size={20} fill="#FFFFFF" />,
    titleKey: "PartnershipPageFeature1Title",
    subtitleKey: "PartnershipPageFeature1Subtitle",
  },
  {
    icon: <Database size={20} fill="#FFFFFF" />,
    titleKey: "PartnershipPageFeature2Title",
    subtitleKey: "PartnershipPageFeature2Subtitle",
  },
  {
    icon: <Gift size={20} fill="#FFFFFF" />,
    titleKey: "PartnershipPageFeature3Title",
    subtitleKey: "PartnershipPageFeature3Subtitle",
  },
];

export const PartnershipInfoCard = ({ colors }: { colors: PartnerBankColors }) => (
  <Card $colors={colors}>
    {FEATURES.map((feature) => (
      <Feature key={feature.titleKey}>
        <FeatureIcon>{feature.icon}</FeatureIcon>
        <div>
          <FeatureTitle>{i18n.t(Translations[feature.titleKey])}</FeatureTitle>
          <FeatureSubtitle $color={colors.featureSubtitle}>
            {i18n.t(Translations[feature.subtitleKey])}
          </FeatureSubtitle>
        </div>
      </Feature>
    ))}
    <Motivational $colors={colors}>{i18n.t(Translations.PartnershipPageMotivational)}</Motivational>
  </Card>
);
